import "./toggle.scss";

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setDarkThemeAction } from "../../store/action";

import { useSelector } from "react-redux";

const Toggle = () => {
  const dispatch = useDispatch();
  const [isToggled, setToggled] = useState(false);

  const toggleTheme = () => {
    const newThemeState = !isToggled;
    setToggled(newThemeState);
    dispatch(setDarkThemeAction(newThemeState));
  };

  // store
  const darkThemeFromStore = useSelector((state) => state.Reducer.darkTheme);

  return (
    <label className="switch">
      <input type="checkbox" onChange={toggleTheme} checked={darkThemeFromStore} />
      <span className={`slider ${darkThemeFromStore? "white-slider" : ""}`}></span>
    </label>
  );
};

export default Toggle;
